export default __webpack_public_path__ + "dfd04e6bcbf8d0c78defe0b528157e6b.svg";